module.exports = __webpack_public_path__ + "img/_DSC7876-min.3ef91fb4.jpg";